import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { CategoryService } from 'app/services/models/category.service';
import { KindService } from 'app/services/models/kind.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-category',
  templateUrl: './create-category.component.html',
  styleUrls: ['./create-category.component.scss']
})
export class CreateCategoryComponent implements OnInit {
  categoryForm: FormGroup;
  @Input() category: any;
  isEditMode = false;
  kinds: any[] = [];
  constructor(
    private formBuilder: FormBuilder,
    private _coreSidebarService: CoreSidebarService,
    private kindService: KindService,
    private categoryService:CategoryService,
    private toastrService:ToastrService) { }

  async ngOnInit() {
    this.initializeForm();
    await this.getAllKind();
  }

  async getAllKind() {
    const data = await this.kindService.getAllKind('', 0, 100);
    console.log(data);
    this.kinds = data.types;
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(this.category)
    if (changes['category'] && this.category) {
      if (this.categoryForm) {
        this.categoryForm.reset();
      }
  
      this.isEditMode = true;
      if (this.isEditMode && this.category) {
        this.categoryForm.patchValue({
          categoryName: this.category.categoryName,
          kindId: this.category.kindId
        });
      }
    }
  }
  

  initializeForm() {
    this.categoryForm = this.formBuilder.group({
      categoryName: ['', [Validators.required, Validators.maxLength(25)]],
      kindId:[null,[Validators.required]]
    });
  }

  toggleSidebar(name: string): void {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

  async onSubmit() {
    if (this.categoryForm.valid) {
      const categoryName = this.categoryForm.get('categoryName').value;
      const kindId = this.categoryForm.get('kindId').value;

      if (!categoryName || !kindId) {
        console.log('Kategori adı ve türü doldurulmalıdır.');
        return;
      }

      let data;
      console.log('Edit Modu:', this.isEditMode);

      if (!this.category) {
        data = await this.categoryService.createCategory(categoryName,kindId);
      } else {
        data = await this.categoryService.updateCategory(this.category.id,categoryName,kindId);
      }
      console.log(data);
      if (data.status == true) {
        this.categoryService.sendEvent(true);
        this.toastrService.success(data.message);
      } else {
        this.toastrService.error(data.message);
      }

      this.toggleSidebar('create-category');
    } else {
      console.log('Form geçerli değil. Lütfen tüm zorunlu alanları doldurun.');
    }
  }

}
